let CoinMatchRedirector = xClass("CoinMatchRedirector", BaseRedirector)
CoinMatchRedirector.prototype.getName = function () {
    return "coinMatch"
}
CoinMatchRedirector.prototype.redirect = function () {
    let param = this.param;

    let scene = cc.Director.getInstance().getRunningScene();
    if (!scene || scene.name === 'PreloadScene') {
        return false;
    } 

    let um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }

    let isCoinMatch = param["type"] && param["type"] === this.getName();
    if (!isCoinMatch) {
        return  true;
    }
        
    let CoinMatchLogic = require("activity/CoinMatchActivity/CoinMatchLogic")
    if (!CoinMatchLogic.isOpen() || !CoinMatchLogic.canActive()) {
        Toast.make(getText("coin.match.share.notopen"));
        return true;
    }
    
    let uid = um.uid;        
    let inviteCode = param["inviteCode"] == null? null: +param["inviteCode"];
    let isMythis = inviteCode === uid || false;
    
    let isShowOff = param["isShowOff"] == true;
    if (isMythis && !isShowOff) {
        Toast.make(getText("coin.match.share.self"));
        return true;
    }

    let shareData = {}
    //  判断是否为关卡内邀请链接
    if (param.shareType) {
        shareData.shareType = param.shareType
        shareData.shareId = param.shareId
        shareData.uid = inviteCode
        shareData.data = {}
    } else {
        shareData.inviteCode = inviteCode
        shareData.isShowOff = isShowOff
    }
    

    if (!CoinMatchLogic.isActive) {
        CoinMatchLogic.stashShareData(shareData);
        return true;
    }

    let inHome = scene.name === "HomeScene";
    if (!inHome) {
        CoinMatchLogic.processShareData(shareData);
        return true;
    }
    
    return new Promise((resolve)=> {        
        let isBusy = CoinMatchLogic.show(
            ()=> {
                CoinMatchLogic.processShareData(shareData);
                resolve();
            },
            ()=> {
                CoinMatchLogic.processShareData(shareData);
                resolve();
            }
        );
        if (isBusy) {
            CoinMatchLogic.processShareData(shareData);
            resolve();
        }
    });
}

CoinMatchRedirector.prototype.hasHighPriorityAction = function () {
    return false;
}

module.exports = CoinMatchRedirector